import React, {
  FC,
  useState,
  Dispatch,
  SetStateAction,
  useEffect,
} from 'react';

import { Container, PaintedBall } from './styles';

interface ToggleSwitcherProps {
  setHasPlacesLimit: Dispatch<SetStateAction<boolean>>;
  defaultValue: boolean;
}

const ToggleSwitcher: FC<ToggleSwitcherProps> = ({
  setHasPlacesLimit,
  defaultValue,
}) => {
  const [isActive, toggleIsActive] = useState(defaultValue);

  useEffect(() => {
    setHasPlacesLimit(isActive);
  }, [isActive]);

  return (
    <Container isActive={isActive}>
      <input type="checkbox" id="checkbox" />

      <label
        role="presentation"
        htmlFor="checkbox"
        onClick={() => toggleIsActive(!isActive)}
        onKeyDown={() => toggleIsActive(!isActive)}
      >
        <PaintedBall isActive={isActive} />
        <p className="toggle-text">{isActive ? 'Sim' : 'Não'}</p>
      </label>
    </Container>
  );
};

export default ToggleSwitcher;
